export default "/Start.png";